"use client";

import T from "@marginly/ui/components/typography";
import { useAccount } from "wagmi";

import { useMarginlyApi } from "@/hooks/api";

import { usePrices } from "../util/use-prices";
import {
  arbitrumSections,
  blastPools,
  mainnetSections,
} from "./farm-sections-info";
import { Section } from "./section";
import { Banner, SectionGrid } from "./styled";

const getSectionsByChain = (chain: string) => {
  if (chain === "arbitrum") {
    return arbitrumSections;
  }
  if (chain === "mainnet") {
    return mainnetSections;
  }
  return blastPools;
};

export default function Farm({ chainName }: { chainName: string }) {
  const sections = getSectionsByChain(chainName);
  const account = useAccount();

  const { data: userPoints } = useMarginlyApi({
    enabled: Boolean(account.address),
    endpoint: "userPoints",
    args: [account.address],
  });

  const priceByToken = usePrices();

  if (sections.length === 0) {
    return (
      <Banner>
        <img src="/images/farm/empty-farm.png" alt="empty-farm" />
        <T headerM className="header">
          Nothing to farm yet
        </T>
        <T>New pools are coming soon.</T>
      </Banner>
    );
  }

  return (
    <SectionGrid>
      {sections.map((section) => {
        return (
          <Section
            pools={section.pools}
            key={section.id}
            chainName={chainName}
            userPoints={userPoints}
            section={section}
            priceByToken={priceByToken}
          />
        );
      })}
    </SectionGrid>
  );
}
